import { Type } from "@sinclair/typebox";
export const buildingUsageCategories = [
    "industrial",
    "commercial",
    "agricultural",
    "apartment",
    "house",
    "residential",
    "public",
    "other",
    "unknown"
];
export const buildingUsageCategorySchema = Type.Union([
    Type.Literal("industrial"),
    Type.Literal("commercial"),
    Type.Literal("agricultural"),
    Type.Literal("apartment"),
    Type.Literal("house"),
    Type.Literal("residential"),
    Type.Literal("public"),
    Type.Literal("other"),
    Type.Literal("unknown")
]);
export const buildingUsageCategoriesSchema = Type.Array(buildingUsageCategorySchema, {
    maxItems: buildingUsageCategories.length,
    uniqueItems: true
});
const nullableText = Type.Union([Type.String(), Type.Null()]);
export const buildingUsageSchema = Type.Object({
    category: buildingUsageCategorySchema,
    categories: Type.Array(buildingUsageCategorySchema, {
        minItems: 1,
        maxItems: 9,
        uniqueItems: true
    }),
    nature: Type.Union([
        Type.Literal("source"),
        Type.Literal("estimated"),
        Type.Literal("unavailable")
    ]),
    source: nullableText,
    sourceKey: nullableText,
    observedAt: nullableText,
    confidence: Type.Union([Type.Number({ minimum: 0, maximum: 1 }), Type.Null()]),
    rawType: nullableText,
    rawSubtype: nullableText,
    limitation: Type.String(),
    conflicting: Type.Boolean(),
    releaseId: Type.Optional(nullableText),
    sourceArtifactId: Type.Optional(nullableText),
    sourceRecordId: Type.Optional(nullableText),
    association: Type.Optional(Type.Union([
        Type.Literal("source_element"),
        Type.Literal("building_part"),
        Type.Literal("unavailable")
    ]))
}, { additionalProperties: false });
/** Canonical set order keeps caches/cursors stable when checkbox order changes. */
export function normalizeBuildingUsageCategories(values) {
    if (values.length > buildingUsageCategories.length ||
        values.some((value) => !buildingUsageCategories.includes(value))) {
        throw Object.assign(new Error("Filtro uso dell’edificio non valido"), { statusCode: 400 });
    }
    return buildingUsageCategories.filter((category) => values.includes(category));
}
export function parseBuildingUsageCategories(value) {
    if (value === undefined)
        return undefined;
    if (!value || value.length > 150) {
        throw Object.assign(new Error("Filtro uso dell’edificio non valido"), { statusCode: 400 });
    }
    return normalizeBuildingUsageCategories(value.split(","));
}
//# sourceMappingURL=building-usage.js.map